import React from 'react';
import useCounter from '../../../../hooks/useCounter';
import { ICategory } from '../../../../types/category';
import type { ITicketsControllerSector } from '../../../../types/sector';
import NumericInput from '../../FormControls/NumericInput';

interface SectorCounterProps {
  data: ITicketsControllerSector | ICategory;
  isCategory?: boolean;
}

const SectorCounter = ({ data, isCategory }: SectorCounterProps) => {
  const { count, onCategoryCountChange, onCountChange } = useCounter({ data, isCategory });

  return (
    <NumericInput
      min={0}
      max={data.count}
      onChange={isCategory ? onCategoryCountChange : onCountChange}
      value={count}
      isMobile
    />
  );
};

export default SectorCounter;
